import { render, staticRenderFns } from "./planList.vue?vue&type=template&id=48b4a03c&scoped=true"
import script from "./planList.vue?vue&type=script&lang=js"
export * from "./planList.vue?vue&type=script&lang=js"
import style0 from "./planList.vue?vue&type=style&index=0&id=48b4a03c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b4a03c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48b4a03c')) {
      api.createRecord('48b4a03c', component.options)
    } else {
      api.reload('48b4a03c', component.options)
    }
    module.hot.accept("./planList.vue?vue&type=template&id=48b4a03c&scoped=true", function () {
      api.rerender('48b4a03c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/releaseManage/infoFrom/planList.vue"
export default component.exports